import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterRetainerSignedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterRetainerSignedEventProps {
  event: DiscriminatedMatterRetainerSignedEvent;
}

export const MatterRetainerSignedEvent: React.FC<
  MatterRetainerSignedEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <DocumentCheckIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>Agreement fully executed</ActivityDescription>
    </ActivityBody>
  );

  const actions = (
    <ActivityActions>
      <ActivityLink href={`/${event.matter_id}#letters`}>
        {' '}
        View Document
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Engagement Letter Signed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
